import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    checkbox1,
    caseAccounting,
    taxAgencyId,
    taxAgencyName,
    certificate,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [firstTime.name]: false,
  [caseAccounting.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId1.name]: "",
  [taxpayerName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
  [checkbox1.name]: false,
};

export default initialValues;
